import {
  type TableSelection,
  TableSelectionNotice,
} from "@components/ui-kit/table";
import { can } from "@src/utils/components/permissions";
import cx from "classnames";
import { map, omit } from "lodash";
import React from "react";
import s from "./TableBody.module.css";

interface TableBodyProps {
  table: any;
  selection?: TableSelection;
  customTBody?: React.ReactNode;
}

export const TableBody = ({
  table,
  selection,
  customTBody,
}: TableBodyProps) => {
  return (
    <div className={cx(s.tableWrapper)}>
      <table className={cx(table.props.className, s.table)}>
        <thead>
          <tr>
            {map(table.header.cells, (h) => (
              <React.Fragment key={h.props.key}>
                {((h.props.withCan && can(h.props.withCan)) ||
                  !h.props.withCan) && (
                  <th {...omit(h.props, "withCan")}>{h.render()}</th>
                )}
              </React.Fragment>
            ))}
          </tr>
        </thead>
        <tbody>
          {customTBody ? (
            customTBody
          ) : (
            <React.Fragment>
              {selection?.meta.someSelected && (
                <tr>
                  <td colSpan={table.header.cells.length}>
                    <TableSelectionNotice selection={selection} />
                  </td>
                </tr>
              )}
              {map(table.rows, (row) => (
                <tr {...row.props}>
                  {map(row.cells, (cell) => (
                    <React.Fragment key={cell.props.key}>
                      {((cell.props.withCan && can(cell.props.withCan)) ||
                        !cell.props.withCan) && (
                        <td {...omit(cell.props, "withCan")}>
                          {cell.render()}
                        </td>
                      )}
                    </React.Fragment>
                  ))}
                </tr>
              ))}
            </React.Fragment>
          )}
        </tbody>
      </table>
    </div>
  );
};
